import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Table, Input, Button, Space, Typography, Tag } from 'antd';
import { EditOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import api from '../services/api';

const { Title } = Typography;
const { Search } = Input;

const FrmProductoLista = () => {
  const navigate = useNavigate();
  const [productos, setProductos] = useState([]);
  const [loading, setLoading]     = useState(false);
  const searchTimeout = useRef(null);

  const fetchProductos = async (nombre = '') => {
    try {
      setLoading(true);
      const url = nombre
        ? `/Producto/buscar?nombre=${encodeURIComponent(nombre)}`
        : '/Producto';
      const res  = await api.get(url);
      const vals = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data?.$values)
        ? res.data.$values
        : [];
      setProductos(vals);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchProductos(); }, []);

  const handleSearch = (value) => {
    clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(() => fetchProductos(value), 300);
  };

  const columns = [
    {
      title: 'Código',
      dataIndex: 'codProducto',
      width: 90,
    },
    {
      title: 'Nombre',
      dataIndex: 'nombre',
      sorter: (a, b) => (a.nombre ?? '').localeCompare(b.nombre ?? ''),
    },
    {
      title: 'Estado',
      dataIndex: 'estado',
      width: 100,
      render: (v) => (
        <Tag color={v === 1 ? 'green' : 'default'}>
          {v === 1 ? 'Activo' : 'Inactivo'}
        </Tag>
      ),
    },
    {
      title: 'Acciones',
      width: 110,
      render: (_, record) => (
        <Button
          type="primary"
          size="small"
          icon={<EditOutlined />}
          onClick={() => navigate(`/dashboard/producto/${record.id}/editar`)}
        >
          Editar
        </Button>
      ),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Space
        style={{ marginBottom: 16, width: '100%', justifyContent: 'space-between' }}
        wrap
      >
        <Title level={4} style={{ margin: 0, color: '#1890ff' }}>
          Productos
        </Title>
        <Space>
          <Search
            placeholder="Buscar por nombre..."
            allowClear
            onChange={(e) => handleSearch(e.target.value)}
            onSearch={fetchProductos}
            style={{ width: 260 }}
            prefix={<SearchOutlined />}
          />
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => navigate('/dashboard/productonuevo')}
          >
            Nuevo
          </Button>
        </Space>
      </Space>

      <Table
        dataSource={productos}
        columns={columns}
        rowKey="id"
        loading={loading}
        size="small"
        pagination={{ pageSize: 15, showSizeChanger: false }}
      />
    </div>
  );
};

export default FrmProductoLista;
